// removed by extract-text-webpack-plugin
module.exports = {"tabWrapper":"_2m86R_CWqWIL402FxbkRvw","sellingPropertiesContainer":"_3raz0CboUr3z_OgGpdHaRz","flagsImage":"_4ZXaNprwIwqvnQdg7bpeQ","sellingPropertiesContent":"_1t0wBeU46JbCWdiX7XIBD9","containerSlider":"_1D7R5BYAb-RtnfRkF4639l","sliderWrapper":"_3IoRtJoX6iQVbQreKvzR2F","sliderPhoto":"R3iBFFqwRL2fJVDsC0Lp4","slider":"_21uwuUh4h9te7xzO-DvTtg","infoSlider":"_2rIPC2V-kCyuh-fFFhDcpV","sliderComment":"_2BNY_otuCxfU8UbqmdJB_i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TabSellingProperties/TabSellingProperties.scss
// module id = 789
// module chunks = 0